import Vue from 'vue'
import App from './App.vue'
import router from './router'
import request from './api/config'

// Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// Swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// ECharts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

// 全局定义axios实例
Vue.prototype.$http = request

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')